export default __webpack_public_path__ + "static/media/OpenCloudBuckets_Dashboard.b174ca9c.svg";